/* DK-FIT theme JS — mobile menu, reveal-on-scroll, FAQ single-open, pricing toggle. */
(function () {
  document.documentElement.classList.add('js');

  document.addEventListener('DOMContentLoaded', function () {
    /* ----- Mobile menu ----- */
    var header = document.querySelector('[data-site-header]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (header && toggle) {
      toggle.addEventListener('click', function () {
        var open = header.classList.toggle('is-menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('menu-locked', open);
      });
      header.querySelectorAll('.mobile-menu a').forEach(function (link) {
        link.addEventListener('click', function () {
          header.classList.remove('is-menu-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('menu-locked');
        });
      });
    }

    /* ----- Reveal on scroll ----- */
    var revealEls = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    /* ----- FAQ teaser: only one item open at a time ----- */
    document.querySelectorAll('[data-faq-single]').forEach(function (group) {
      group.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });

    /* ----- Pricing Full/Split toggle ----- */
    document.querySelectorAll('[data-pricing]').forEach(function (section) {
      var buttons = section.querySelectorAll('[data-pay-plan]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var plan = btn.getAttribute('data-pay-plan');
          buttons.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          section.querySelectorAll('[data-price-full]').forEach(function (el) {
            el.textContent = plan === 'full' ? el.getAttribute('data-price-full') : el.getAttribute('data-price-split');
          });
          section.querySelectorAll('[data-sub-full]').forEach(function (el) {
            el.textContent = plan === 'full' ? el.getAttribute('data-sub-full') : el.getAttribute('data-sub-split');
          });
        });
      });
    });
  });
})();
